/**
 * AVTR GSAP Animations v1.2
 * AvatarDesigns Design System
 *
 * Requiere GSAP 3 + ScrollTrigger (cargados desde CDN antes de este script)
 *
 * - Parallax en hero y banners editoriales
 * - Hero title word-by-word reveal
 * - Section content entrance animations
 * - Page transitions (fade overlay)
 * - Card magnetic hover (desktop)
 */

(function () {
  'use strict';

  /* ── Esperar que GSAP esté disponible ── */
  function waitForGSAP(cb) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      cb();
      return;
    }
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        clearInterval(interval);
        gsap.registerPlugin(ScrollTrigger);
        cb();
      }
      if (tries > 60) clearInterval(interval);
    }, 100);
  }

  /* ── 1. PARALLAX ── */
  function initParallax() {
    /* Hero media */
    var heroMedia = document.querySelector('.avtr-hero__media');
    var hero = document.querySelector('.avtr-hero');
    if (heroMedia && hero && !hero.classList.contains('avtr-hero--video')) {
      gsap.to(heroMedia, {
        yPercent: 22,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: 1.2,
        },
      });
    }

    /* Hero content fade out while scrolling */
    var heroContent = document.querySelector('.avtr-hero__content');
    if (heroContent && hero) {
      gsap.to(heroContent, {
        yPercent: 18,
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'center top',
          end: 'bottom top',
          scrub: 1,
        },
      });
    }

    /* Editorial banners parallax */
    var editorials = document.querySelectorAll('.avtr-editorial');
    editorials.forEach(function (banner) {
      var media = banner.querySelector('.avtr-editorial__media');
      if (!media) return;
      gsap.to(media, {
        yPercent: 14,
        ease: 'none',
        scrollTrigger: {
          trigger: banner,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1.5,
        },
      });
    });
  }

  /* ── 2. HERO TEXT REVEAL (word split) ── */
  function initHeroTextReveal() {
    var heroTitle = document.querySelector('.avtr-hero__title');
    if (!heroTitle) return;

    /* Split into word spans */
    var rawText = heroTitle.textContent.trim();
    var words = rawText.split(/\s+/);
    heroTitle.innerHTML = words
      .map(function (word) {
        return (
          '<span class="avtr-word-mask" style="overflow:hidden;display:inline-block;vertical-align:bottom;">' +
          '<span class="avtr-word-inner" style="display:inline-block;">' +
          word +
          '</span></span>'
        );
      })
      .join('\u00A0'); /* non-breaking space between words */

    var eyebrow = document.querySelector('.avtr-hero__eyebrow');
    var subtitle = document.querySelector('.avtr-hero__subtitle');
    var actions = document.querySelector('.avtr-hero__actions');
    var scrollInd = document.querySelector('.avtr-hero__scroll-indicator');

    gsap.set('.avtr-word-inner', { y: '110%' });
    if (eyebrow)   gsap.set(eyebrow,   { opacity: 0, y: 14 });
    if (subtitle)  gsap.set(subtitle,  { opacity: 0, y: 18 });
    if (actions)   gsap.set(actions,   { opacity: 0, y: 14 });
    if (scrollInd) gsap.set(scrollInd, { opacity: 0 });

    var tl = gsap.timeline({ delay: 0.15 });

    if (eyebrow) {
      tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' });
    }

    tl.to(
      '.avtr-word-inner',
      { y: '0%', duration: 0.85, stagger: 0.06, ease: 'power4.out' },
      eyebrow ? '-=0.4' : '+=0'
    );

    if (subtitle) {
      tl.to(subtitle, { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4');
    }
    if (actions) {
      tl.to(actions, { opacity: 1, y: 0, duration: 0.65, ease: 'power3.out' }, '-=0.45');
    }
    if (scrollInd) {
      tl.to(scrollInd, { opacity: 1, duration: 0.5 }, '-=0.2');
    }
  }

  /* ── 3. SECTION CONTENT REVEAL (scroll-triggered) ── */
  function initSectionReveal() {
    /* Editorial banners */
    var editorialContents = document.querySelectorAll(
      '.avtr-editorial__content:not(.gsap-init)'
    );
    editorialContents.forEach(function (el) {
      el.classList.add('gsap-init');
      gsap.fromTo(
        el,
        { opacity: 0, y: 48 },
        {
          opacity: 1,
          y: 0,
          duration: 1.1,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 78%', once: true },
        }
      );
    });

    /* Section headers (eyebrow + title row) */
    var sectionHeaders = document.querySelectorAll(
      '.avtr-section-header:not(.gsap-init)'
    );
    sectionHeaders.forEach(function (el) {
      el.classList.add('gsap-init');
      gsap.fromTo(
        el,
        { opacity: 0, y: 28 },
        {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        }
      );
    });

    /* Image banners */
    var imageBanners = document.querySelectorAll(
      '.image-banner:not(.gsap-init)'
    );
    imageBanners.forEach(function (el) {
      el.classList.add('gsap-init');
      var media = el.querySelector('.media');
      if (media) {
        gsap.fromTo(
          media,
          { scale: 1.06 },
          {
            scale: 1,
            duration: 1.4,
            ease: 'power2.out',
            scrollTrigger: { trigger: el, start: 'top 85%', once: true },
          }
        );
      }
    });
  }

  /* ── 4. COLLECTION GRID STAGGER (GSAP version) ── */
  function initGridStagger() {
    var grids = document.querySelectorAll(
      '.product-grid:not(.gsap-grid-init)'
    );
    grids.forEach(function (grid) {
      grid.classList.add('gsap-grid-init');
      var items = grid.querySelectorAll('.grid__item');
      if (!items.length) return;

      gsap.fromTo(
        items,
        { opacity: 0, y: 32 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: { each: 0.07, from: 'start' },
          ease: 'power3.out',
          scrollTrigger: {
            trigger: grid,
            start: 'top 82%',
            once: true,
          },
        }
      );
    });
  }

  /* ── 5. PAGE TRANSITIONS ── */
  function initPageTransitions() {
    /* Overlay element */
    var overlay = document.getElementById('avtr-page-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'avtr-page-overlay';
      overlay.style.cssText =
        'position:fixed;inset:0;background:#0A0A0A;z-index:9998;' +
        'pointer-events:none;opacity:1;will-change:opacity;';
      document.body.appendChild(overlay);
    }

    /* Page enter fade */
    gsap.to(overlay, {
      opacity: 0,
      duration: 0.55,
      ease: 'power2.out',
      delay: 0.05,
      onComplete: function () {
        overlay.style.pointerEvents = 'none';
      },
    });

    /* Back/forward cache: al volver desde checkout o pasarela de pago
       la página se restaura con el overlay opaco; lo ocultamos. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      gsap.killTweensOf(overlay);
      gsap.set(overlay, { opacity: 0 });
      overlay.style.pointerEvents = 'none';
    });

    /* Page exit on internal link clicks */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var link = e.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript:') ||
        link.getAttribute('target') === '_blank' ||
        link.closest('form') ||
        link.closest('.cart-drawer') ||
        link.closest('[data-cart-drawer]') ||
        link.hasAttribute('data-no-transition')
      ) {
        return;
      }

      e.preventDefault();
      overlay.style.pointerEvents = 'all';
      gsap.to(overlay, {
        opacity: 1,
        duration: 0.28,
        ease: 'power2.in',
        onComplete: function () {
          window.location.href = href;
        },
      });
    });
  }

  /* ── 6. MAGNETIC CARD HOVER (desktop only) ── */
  function initMagneticCards() {
    if (
      window.innerWidth < 990 ||
      window.matchMedia('(hover: none)').matches
    ) {
      return;
    }

    function applyMagnetic() {
      var cards = document.querySelectorAll(
        '.card-wrapper:not(.gsap-magnetic)'
      );
      cards.forEach(function (card) {
        card.classList.add('gsap-magnetic');

        card.addEventListener('mousemove', function (e) {
          var rect = card.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width - 0.5) * 6;
          var y = ((e.clientY - rect.top) / rect.height - 0.5) * 6;
          gsap.to(card, { x: x, y: y, duration: 0.35, ease: 'power2.out' });
        });

        card.addEventListener('mouseleave', function () {
          gsap.to(card, {
            x: 0,
            y: 0,
            duration: 0.6,
            ease: 'elastic.out(1, 0.55)',
          });
        });
      });
    }

    applyMagnetic();

    /* Re-apply after section loads */
    document.addEventListener('shopify:section:load', function () {
      setTimeout(applyMagnetic, 200);
    });
  }

  /* ── 7. ANIMATED COUNTERS (si hay elementos con data-count) ── */
  function initCounters() {
    var counters = document.querySelectorAll('[data-avtr-count]');
    counters.forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-avtr-count')) || 0;
      var suffix = el.getAttribute('data-avtr-suffix') || '';
      var obj = { val: 0 };

      gsap.to(obj, {
        val: target,
        duration: 2,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%', once: true },
        onUpdate: function () {
          el.textContent =
            (Number.isInteger(target)
              ? Math.round(obj.val)
              : obj.val.toFixed(1)) + suffix;
        },
      });
    });
  }

  /* ── 8. REFRESH ON RESIZE ── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }, 250);
  });

  /* ── INIT ── */
  function init() {
    initParallax();
    initHeroTextReveal();
    initSectionReveal();
    initGridStagger();
    initPageTransitions();
    initMagneticCards();
    initCounters();
  }

  waitForGSAP(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });

  /* Re-run on Shopify section reload */
  document.addEventListener('shopify:section:load', function () {
    waitForGSAP(function () {
      setTimeout(function () {
        ScrollTrigger.refresh();
        initSectionReveal();
        initGridStagger();
      }, 200);
    });
  });
})();
